/**
 * Internal dependencies
 */
import color from './color';
import spacing from './spacing';
import typography from './typography';
export const styleDefinitions = [...color, ...spacing, ...typography];
//# sourceMappingURL=index.js.map